export default {
  KETO: "Keto",
  PLANT: "Plant",
  STANDARD: "Standard"
};
